/* eslint-disable react/no-array-index-key */
import React from "react";

// Material
import { makeStyles } from "@material-ui/core/styles";

// Assets
import headingArrow from "../../assets/icons/heading-arrow.svg";

// Contents
import Text, { types } from "../Text/Text";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "relative",
    width: "100%"
  },
  content: {
    marginBottom: theme.spacing(4),
    maxWidth: "530px",
    width: "100%"
  },
  imgWrapper: {
    overflow: "hidden",
    height: "100%",
    display: "flex",
    justifyContent: "center"
  },
  image: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
    width: "100%",
    display: "block",
    minWidth: "540px"
  },
  titleWrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: theme.spacing(1.5),
    padding: "0 10%"
  },
  headingArrow: {
    marginRight: theme.spacing(2),
    height: 18,
    [theme.breakpoints.down("xs")]: {
      marginRight: theme.spacing(1)
    }
  },
  heading: {
    textTransform: "capitalize",
    textAlign: "center",
    fontWeight: 600,
    padding: "0 10%"
  },
  title: {
    fontWeight: 500,
    textAlign: "center",
    padding: "0 10%"
  },
  description: {
    marginBottom: theme.spacing(1),
    textAlign: "center",
    padding: "0 10%"
  }
}));

const HomeSubsectionResponsive = ({
  subsections,
  descriptionForTitle = false
}) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {subsections.map(({ heading, title, descriptions, mobileBg, id }) => (
        <div key={id} className={classes.content}>
          {mobileBg && (
            <div className={classes.imgWrapper}>
              <img src={mobileBg} alt="" className={classes.image} />
            </div>
          )}
          <div className={classes.titleWrapper}>
            <Text
              component="h4"
              className={classes.heading}
              type={types.subsectionHeadingMobile}
            >
              <img src={headingArrow} alt="" className={classes.headingArrow} />
              {descriptionForTitle ? title : heading}
            </Text>
          </div>
          {!descriptionForTitle && (
            <Text type={types.subsectionTitleMobile} className={classes.title}>
              {title}
            </Text>
          )}
          {descriptions.map((data, i) => (
            <Text
              key={i}
              type={types.subsectionDescriptionMobile}
              className={classes.description}
            >
              {data}
            </Text>
          ))}
        </div>
      ))}
    </div>
  );
};

export default HomeSubsectionResponsive;
